
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import {AttendanceProps} from "types/props-obj/AttendanceProps";
// import {useContext} from "react";
// import AuthContext from "contexts/JWTContext";

const initialState: AttendanceProps = {
    apiEndPoint: "attendance",
    pageLimit: 5,
    pageNumber: 1,
    isOpen: false,
    list: [],
    item: null,
    error: null,
    alertPopup: false
};

const attendance = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all Item list
        getList(state, action) {
            state.list.push(action.payload);
            state.list = state.list.filter((liste) => liste.id !== 0);
            state.isLoading=false;
        },
        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        },
        openToggle(state, action) {
            state.isOpen = action.payload.isOpen;
        },
        // get Item details
        setItem(state, action) {
            state.item = action.payload;
            state.isLoading=false;
        },

        // GET Items
        setItemsSuccess(state, action) {
            state.list = action.payload.data;
            state.current_page=action.payload.current_page;
            state.last_page=action.payload.last_page;
            state.total=action.payload.total;
            state.isLoading=false;
        },

        // ADD Item
        addItemSuccess(state, action) {
            state.list = [...state.list,action.payload];
            state.isLoading=false;
        },

        // EDIT Item
        editItemSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id === action.payload.id);
            state.item=action.payload;
            state.list[foundIndex] = action.payload;
            state.isLoading=false;
        },

        deleteItemSuccess(state, action) {
            state.list = state.list.filter((item) => item.id !== action.payload);
        },



        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },

    }
});


export default attendance.reducer;

function getApiEndPoint(){
    return store.getState().attendance.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setLoading,setPageLimit,setApiEndPoint } = attendance.actions;
export function getList(params:any={}) {
    return async () => {
        dispatch(attendance.actions.setLoading(true));
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(attendance.actions.setItemsSuccess(response.data));
        } catch (error) {
            dispatch(attendance.actions.hasError(error));
        }
    };
}

export function getItem(id: number | undefined) {
    return async () => {
        dispatch(attendance.actions.setLoading(true));

        try {
            const response = await axios.get([getApiEndPoint(),  id].join('/'));
            dispatch(attendance.actions.setItem(response.data));
        } catch (error) {
            dispatch(attendance.actions.hasError(error));
            dispatch(attendance.actions.setLoading(false));
        }
    };
}

export function addItem(ls:any) {

    return async () => {
        dispatch(attendance.actions.setLoading(true));
        try {
            const response = await axios.post(getApiEndPoint(), ls,{headers:{'Content-Type': 'multipart/form-data'}});
            dispatch(attendance.actions.addItemSuccess(response.data));
            // const context = useContext(AuthContext);
            // context?.reloadUser()
        } catch (error) {
            dispatch(attendance.actions.hasError(error));
            dispatch(attendance.actions.setLoading(false));
        }
    };
}

export function editItem(id: number | undefined,ls: any) {
    return async () => {
        dispatch(attendance.actions.setLoading(true));
        try {
            const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
            dispatch(attendance.actions.editItemSuccess(response.data));
        } catch (error) {
            dispatch(attendance.actions.hasError(error));
            dispatch(attendance.actions.setLoading(false));
        }
    };
}

export function deleteItem(id: number | undefined) {
    return async () => {
        try {
            await axios.delete([getApiEndPoint(),  id].join('/'));
            dispatch(attendance.actions.deleteItemSuccess(id));
        } catch (error) {
            dispatch(attendance.actions.hasError(error));
        }
    };
}